export default "__VITE_ASSET__77c7a364__"